import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

function extractItemsFromCarousel(carouselEl) {
    const item_list_name = carouselEl.dataset.itemListName || '';
    const item_list_id = carouselEl.dataset.itemListId || '';
    const items = [
        ...carouselEl.querySelectorAll('.events-carousel-block__sliderItem'),
    ].map(card => ({
        item_id: card.dataset.id || '',
        item_name: card.dataset.name || '',
        item_brand: card.dataset.brand || '',
        item_category: card.dataset.category || '',
        item_category2: card.dataset.subcategory || '',
        item_category3: card.dataset.city || '',
        item_category4: card.dataset.venue || '',
        item_list_name,
        item_list_id,
    }));
    return { items, item_list_name, item_list_id };
}

function trackViewItemList(carouselEl) {
    const { items, item_list_name, item_list_id } =
        extractItemsFromCarousel(carouselEl);
    if (items.length === 0) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'view_item_list',
        ecommerce: {
            item_list_name,
            item_list_id,
            items,
        },
    });
}

function trackSelectItem(cardEl, carouselEl) {
    if (!cardEl || !carouselEl) return;
    const item_list_name = carouselEl.dataset.itemListName || '';
    const item_list_id = carouselEl.dataset.itemListId || '';
    const item = {
        item_id: cardEl.dataset.id || '',
        item_name: cardEl.dataset.name || '',
        item_brand: cardEl.dataset.brand || '',
        item_category: cardEl.dataset.category || '',
        item_category2: cardEl.dataset.subcategory || '',
        item_category3: cardEl.dataset.city || '',
        item_category4: cardEl.dataset.venue || '',
        item_list_name,
        item_list_id,
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'select_item',
        ecommerce: {
            items: [item],
        },
    });
}

class EventsCarousel {
    constructor(el) {
        if (!this.set(el)) return;
        if (
            document.readyState === 'complete' ||
            (document.readyState !== 'loading' &&
                !document.documentElement.doScroll)
        ) {
            this.init();
        } else {
            document.addEventListener('DOMContentLoaded', this.init.bind(this));
        }
    }
    set(el) {
        if (!el) return false;
        this.root = el;
        this.slider = this.root.querySelector('[data-events-carousel-slider]');
        this.pagination = this.root.querySelector(
            '[data-events-carousel-pagination]'
        );
        this.prev = this.root.querySelector('[data-events-carousel-prev]');
        this.next = this.root.querySelector('[data-events-carousel-next]');
        this.swiper = null;
        return true;
    }
    init() {
        this.initSwiper();
        this.initGA4ViewItemListObserver();
        this.slider.addEventListener('click', e => {
            let target = e.target;
            while (
                target &&
                !target.classList.contains('events-carousel-block__sliderItem')
            ) {
                target = target.parentElement;
            }
            if (
                target &&
                target.classList.contains('events-carousel-block__sliderItem')
            ) {
                trackSelectItem(target, this.root);
            }
        });
    }

    initGA4ViewItemListObserver() {
        if (!this.root) return;
        const observer = new window.IntersectionObserver(
            (entries, obs) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        if (!this._ga4ViewItemListSent) {
                            this._ga4ViewItemListSent = true;
                            if (typeof trackViewItemList === 'function') {
                                trackViewItemList(this.root);
                            }
                        }
                    }
                });
            },
            { threshold: 0.5 }
        );
        observer.observe(this.root);
    }
    initSwiper() {
        if (!this.slider) return;
        this.swiper = new Swiper(this.slider, {
            modules: [Pagination, Navigation],
            slidesPerView: 'auto',
            spaceBetween: 16,
            centeredSlides: false,
            loop: false,
            navigation: {
                prevEl: this.prev,
                nextEl: this.next,
            },
            pagination: {
                el: this.pagination,
                clickable: true,
                type: 'bullets',
                bulletClass: 'slider-pagination__bullet',
                bulletActiveClass: 'active',
            },
        });
    }
}

const initEventsCarousels = () => {
    const sections = document.querySelectorAll('[data-events-carousel]');
    if (sections) sections.forEach(item => new EventsCarousel(item));
};

initEventsCarousels();
